import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    buttons: 'flex gap-4',
    button: 'flex-1',
    error: 'heading-s text-error mt-1'
  },
  variants: {
    active: {
      true: {
        button: 'bg-blue'
      }
    }
  }
});
